import { useMemo } from "react";

import type { ViewportToolsetId } from "@/viewport-tools/core/contracts";
import type { ViewportToolsetRailControllerMap } from "@/viewport-tools/rail/types";
import {
  getViewportToolsetsForPlacement,
  type ViewportViewId,
} from "@/viewport-tools/view-config";
import { VIEWPORT_TOOLSET_PLACEMENTS } from "@/viewport-tools/core";

export interface ViewportToolsetControllersComposition {
  enabledToolsets: ViewportToolsetId[];
  controllers: ViewportToolsetRailControllerMap;
}

export function composeViewportToolsetControllers(
  enabledToolsets: ViewportToolsetId[],
  controllersById: ViewportToolsetRailControllerMap
): ViewportToolsetRailControllerMap {
  const next: ViewportToolsetRailControllerMap = {};
  for (const toolsetId of enabledToolsets) {
    const controller = controllersById[toolsetId];
    if (controller) {
      (
        next as Record<ViewportToolsetId, (typeof controller) | undefined>
      )[toolsetId] = controller;
    }
  }
  return next;
}

export function useViewportToolsetControllers(
  viewId: ViewportViewId,
  controllersById: ViewportToolsetRailControllerMap
): ViewportToolsetControllersComposition {
  const leftRailToolsets = getViewportToolsetsForPlacement(
    viewId,
    VIEWPORT_TOOLSET_PLACEMENTS.leftRail
  );

  const controllers = useMemo(
    () => composeViewportToolsetControllers(leftRailToolsets, controllersById),
    [controllersById, leftRailToolsets]
  );

  return {
    enabledToolsets: leftRailToolsets,
    controllers,
  };
}
